export const countriesSelect = [
  { text: 'Argentina (200)', value: 'Argentina (200)' },
  { text: 'Bolivia (202)', value: 'Bolivia (202)' },
  { text: 'Brasil (203)', value: 'Brasil (203)' },
  { text: 'Chile (208)', value: 'Chile (208)' },
  { text: 'Paraguay (221)', value: 'Paraguay (221)' },
  { text: 'Perú (222)', value: 'Perú (222)' },
  { text: 'Uruguay (225)', value: 'Uruguay (225)' },
];
